import { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus } from '@fortawesome/free-solid-svg-icons';
import { API_BASE_URL } from '../../api';

export default function LoyaltyCardGenerator({ patientId, onCreated }) {
    const [loading, setLoading] = useState(false);

    const handleCreate = async () => {
        setLoading(true);
        try {
            const { data } = await axios.post(
                `${API_BASE_URL}/api/v1/loyalty-cards`,
                { patientId },
                { withCredentials: true }
            );
            toast.success('Carte de fidélité créée avec succès');
            onCreated?.(data);
        } catch (err) {
            const msg = err.response?.data?.message || 'Erreur lors de la création de la carte';
            toast.error(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: '8px 0 16px', textAlign: 'center' }}>
            <p style={{ fontSize: 14, color: '#6b7280', lineHeight: 1.7, margin: '0 0 28px' }}>
                Ce patient n'a pas encore de carte de fidélité.<br />
                Créez-en une pour commencer à accumuler des points et bénéficier de réductions.
            </p>

            <button
                onClick={handleCreate}
                disabled={loading}
                style={{
                    display: 'inline-flex', alignItems: 'center', gap: 8,
                    background: '#2563eb', color: '#fff',
                    border: 'none', borderRadius: 10,
                    padding: '11px 28px',
                    fontSize: 14, fontWeight: 600,
                    cursor: loading ? 'not-allowed' : 'pointer',
                    opacity: loading ? 0.7 : 1,
                    boxShadow: '0 2px 8px rgba(37,99,235,0.25)',
                    width: '100%',
                    justifyContent: 'center',
                }}
            >
                <FontAwesomeIcon icon={faCirclePlus} />
                {loading ? 'Création en cours...' : 'Créer une carte de fidélité'}
            </button>
        </div>
    );
}
